import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b49a996"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CollectionDetail = _resolveComponent("CollectionDetail")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_CollectionDetail, { collectionId: _ctx.selectedCollectionId }, null, 8, ["collectionId"])
    ]),
    _createVNode(_component_router_view, { collectionId: _ctx.selectedCollectionId }, null, 8, ["collectionId"])
  ], 64))
}